import { useEffect, useState } from "react";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import RadioButton from "./RadioButton";

const RadioOption = ({
  title,
  noticeMessage,
  option1,
  option2,
  option3,
  optionChange,
  initialOption,
  component,
}) => {
  const [selectedOption, setSelectedOption] = useState(initialOption);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    optionChange(option);
  };

  useEffect(() => {
    if (initialOption) {
      setSelectedOption(initialOption);
    }
  }, [initialOption]);

  return (
    <div className="optionSelectBox" style={{ marginTop: "16px" }}>
      <div className="hrz-wrapper">
        <div
          className="subtitle-in-box"
          style={{ fontFamily: "notoSans-medium" }}
        >
          {title}
        </div>
        {noticeMessage !== "" ? (
          <IconInfo
            width="20px"
            height="20px"
            fill="#888888"
            style={{ marginLeft: "auto" }}
          />
        ) : (
          ""
        )}
        <div className="text-for-notice" style={{ marginLeft: "4px" }}>
          {noticeMessage}
        </div>
      </div>

      <div className="hrz-wrapper" style={{ marginTop: "14px" }}>
        <RadioButton
          option1={option1}
          option2={option2}
          option3={option3}
          selectedOption={selectedOption}
          optionChange={handleOptionChange}
        />
      </div>

      {component}
    </div>
  );
};

export default RadioOption;
